import React, { createContext, FunctionComponent, useContext, useReducer } from 'react';

import { Action, reducer } from './reducer';
export interface StateContext {
  data;
}
export interface Store {
  state: StateContext;
  dispatch?: React.Dispatch<Action>;
}

const defaultState: StateContext = { data: null };

const context = createContext<Store>({ state: defaultState });

export const useStateContext = () => useContext(context);
type Props = { backgroundColor?; backgroundImage?; children? };
export const StateProvider: FunctionComponent<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  return <context.Provider value={{ state, dispatch }}>{children}</context.Provider>;
};
